import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import HotRecommend from './components/HotRecommend';
import CategorySection from './components/CategorySection';
import FeatureZone from './components/FeatureZone';
import LatestUpdate from './components/LatestUpdate';
import FaqSection from './components/FaqSection';
import CtaSection from './components/CtaSection';

export default function Home() {
  useEffect(() => {
    document.title = '下拉式完整版免费阅读 无删减漫画免费阅读「下拉观看」-亲亲漫画网';
  }, []);

  return (
    <div className="min-h-screen bg-background-50">
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebPage',
            name: '亲亲漫画网 - 下拉式完整版免费漫画阅读',
            description: '亲亲漫画网提供下拉式完整版免费阅读，无删减韩国漫画资源充足，下拉观看流畅不卡顿，让您免费畅享完整版韩国漫画的甜蜜剧情与细腻画风。',
            url: 'https://yutuocq.cn',
            isPartOf: {
              '@type': 'WebSite',
              name: '亲亲漫画网',
              url: 'https://yutuocq.cn',
            },
          }),
        }}
      />
      <Navbar />
      <main>
        <HeroSection />
        <HotRecommend />
        <CategorySection />
        <FeatureZone />
        <LatestUpdate />
        <FaqSection />
        <CtaSection />
      </main>
      <Footer />
    </div>
  );
}